export default "__VITE_ASSET__606d1808__"